import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import './Collections.css';

function Collections() {
  const navigate = useNavigate();
  const [collectionImages, setCollectionImages] = useState({});
  const [loading, setLoading] = useState(true);

  const FIXED_COLLECTIONS = [
    {
      id: 'clothing',
      title: 'Clothing',
      defaultImg: require("../../assets/images/collection-clothing.jpg"),
      filter: 'Clothing',
    },
    {
      id: 'accessories',
      title: 'Accessories',
      defaultImg: require("../../assets/images/collection-accessories.jpg"),
      filter: 'Accessories',
    },
    {
      id: 'printed',
      title: 'Printed Materials',
      defaultImg: require("../../assets/images/collection-printed.jpg"),
      filter: 'Printed Materials',
    },
    {
      id: 'promotional',
      title: 'Promotional Items',
      defaultImg: require("../../assets/images/collection-promotional.jpg"),
      filter: 'Promotional Materials',
    },
    {
      id: 'packaging',
      title: 'Packaging & Display',
      defaultImg: require("../../assets/images/collection-packaging.jpg"),
      filter: 'Packaging & Display',
    },
    {
      id: 'sublimation',
      title: 'Full Sublimation',
      defaultImg: require("../../assets/images/collection-sublimation.jpg"),
      filter: 'Full Sublimation',
    },
  ];

  useEffect(() => {
    loadCollectionImages();
  }, []);

  async function loadCollectionImages() {
    try {
      const snap = await getDoc(doc(db, 'settings', 'homepage'));
      if (snap.exists()) {
        const data = snap.data();
        setCollectionImages(data.collectionImages || {});
      }
    } catch (err) {
      console.error('Error loading collection images:', err);
    } finally {
      setLoading(false);
    }
  }

  const handleCardClick = (filter) => {
    navigate('/collections', { state: { filter } });
  };

  if (loading) {
    return (
      <section className="collections-container">
        <h2 className="collections-heading">Collections</h2>
        <div className="collections-skeleton-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="collections-skeleton-card" />
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className="collections-container">
      <h2 className="collections-heading">Collections</h2>
      <div className="collections-grid">
        {FIXED_COLLECTIONS.map((item) => {
          const imageUrl = collectionImages[item.id] || item.defaultImg;
          return (
            <div
              key={item.id}
              className="collection-card"
              onClick={() => handleCardClick(item.filter)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleCardClick(item.filter)}
              aria-label={`Browse ${item.title}`}
            >
              <img
                src={imageUrl}
                alt={item.title}
                className="collection-img"
              />
              <div className="collection-overlay">
                <h3>{item.title}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Collections;